import React from 'react';
import PropTypes from 'prop-types';
import { BroadcastLabel, GameActionDetailsContainer, TagLabelAlert } from '../GameContext.style';
import DecisionsDataContainer from '../../Decisions/containers/DecisionsDataContainer';
import { ProductButtons } from './ProductButtons';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';

export const GameActionsLayer = ({ gameState, broadcasters, freeGame }) => {
    const translate = useTranslate();
    const watchOnLabel = translate('label_watch_on', 'Watch on:');
    const watchFreeLabel = translate('label_watch_free', 'Watch Free');
    return (
        <>
            {gameState === 'P' || gameState === 'L'
                ? <GameActionDetailsContainer>
                    {freeGame && <TagLabelAlert>{watchFreeLabel}</TagLabelAlert>}
                    {broadcasters?.length > 0 && <BroadcastLabel>{`${watchOnLabel} ${broadcasters?.join(', ')}`}</BroadcastLabel>}
                </GameActionDetailsContainer>
                : <DecisionsDataContainer customFormat={{
                    useDecisionBox: false
                }}/>
            }
            <ProductButtons gameState={gameState}/>
        </>
    );
};

GameActionsLayer.propTypes = {
    gameState: PropTypes.string,
    broadcasters: PropTypes.arrayOf(PropTypes.string),
    freeGame: PropTypes.bool
};
